var map = {
	"./at-rail-terminal-on-train.svg": 834,
	"./available-for-collection.svg": 835,
	"./departed-by-road.svg": 836,
	"./departed-by-vessel.svg": 837,
	"./departed-port-for-rail-terminal.svg": 838,
	"./discharged.svg": 839,
	"./in-storage.svg": 840,
	"./inbound-at-sea.svg": 841,
	"./inbound-by-road.svg": 842,
	"./inbound.svg": 843,
	"./on-hold.svg": 844,
	"./on-vessel-at-berth.svg": 845,
	"./on-vessel-at-sea.svg": 846,
	"./planned-for-vessel.svg": 847,
	"./ready-for-loading.svg": 848,
	"./release-but-not-yet-bookable.svg": 849,
	"./released-but-not-bookable.svg": 850,
	"./released-for-rail.svg": 851,
	"./released.svg": 852,
	"./unknown.svg": 853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;